import React from 'react';
import { IInvoiceRecipient } from '../../../../InvoiceCreation/types/types';
import { Avatar, AvatarSize } from '../../../../../../DesignSystem/VendorProfile/Avatar';

export const nameTemplate = (recipient: IInvoiceRecipient) => (
  <div className='flex items-center h-[64px]'>
    <div className='w-[0px] bg-action03 h-full mr-[24px]' />
    <Avatar name={recipient.name} id={recipient.externalId} size={AvatarSize.SMALL} />
    <span title={recipient.name} className='font-metricRSemibold text-[14px] text-bw08 ml-[6px]   max-w-[30ch] truncate'>{recipient.name}</span>
  </div>
);
